module.exports = __webpack_public_path__ + "static/HSE_Announcement_Extension_Expiration_Date_to_August_4-449d2a7af5632a9094bd0500534972e1.pdf";